<div [id]="settings?.id" class="datiq-modal">
    <datiq-modal-bg
        [closeOnClick]="settings?.closeOnBgClick"
        [closeOnEsc]="settings?.closeOnEsc"
        (closed)="close()"
    >
        <div datiq-modal-container class="datiq-modal__container">
            <div class="datiq-modal__header">
                <ng-container *ngIf="!!settings?.title">
                    <h1 class="datiq-modal__header__title">
                        {{ settings?.title }}
                    </h1>
                </ng-container>
                <div class="datiq-modal__header__controls">
                    <ng-content select="[datiq-modal-header]"></ng-content>
                </div>
                <ng-container *ngIf="settings?.showClose">
                    <button
                        class="datiq-modal__header__button--close"
                        (click)="clickClose()"
                        mat-icon-button
                        [id]="closeButtonId()"
                    >
                        <mat-icon svgIcon="app:close"></mat-icon>
                    </button>
                </ng-container>
            </div>
            <div class="datiq-modal__body">
                <ng-content select="[datiq-modal-body]"></ng-content>
            </div>
            <div class="datiq-modal__footer">
                <ng-content select="[datiq-modal-footer]"></ng-content>
            </div>
        </div>
    </datiq-modal-bg>
</div>
